import { createRouter, createWebHistory } from 'vue-router'
import i18n from '@/i18n'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Products.vue'),
      meta: { titleKey: 'products.title' }
    },
    {
      path: '/products',
      name: 'Products',
      component: () => import('@/views/Products.vue'),
      meta: { titleKey: 'products.title' }
    },
    {
      path: '/hot',
      name: 'Hot',
      component: () => import('@/views/Home.vue'),
      meta: { titleKey: 'home.heroTitle' }
    },
    {
      path: '/product/:id',
      name: 'ProductDetail',
      component: () => import('@/views/ProductDetail.vue'),
      meta: { titleKey: 'product.detail' }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('@/views/Contact.vue'),
      meta: { titleKey: 'contact.title' }
    }
  ],
  scrollBehavior() {
    return { top: 0 }
  }
})

function updateTitle() {
  const route = router.currentRoute.value
  const titleKey = route.meta.titleKey as string
  if (titleKey) {
    const translated = i18n.global.t(titleKey)
    document.title = `${translated} - CNRU168`
  }
}

router.afterEach(() => {
  updateTitle()
})

export default router
